import { FormFieldType } from '../enums'

export interface IChecklistItem {
  id: string
  question: string
}

export interface IChecklistItemValue {
  id: string
  status: 'ok' | 'notOk' | 'na' | null
  deviation?: string
  comment?: string
}

export interface FormField {
  type: FormFieldType
  name: string
  isRequired?: boolean
  options?: IOption[]
  fieldIndex?: number
  rowIndex?: number
  columnIndex?: number
  identifier?: string
  defaultValue?: string
  disabled?: boolean
  content?: string
  imageWidth?: number
  showInReport?: boolean
  checklistItems?: IChecklistItem[]
}

export const getFieldKey = (field: FormField) => field.identifier ?? field.name

export interface FormLayout {
  fields: FormField[]
}

export interface IOption {
  label: string
  value: any
}

export interface FormRow {
  columns: FormLayout[]
}

export enum formFieldsDefaultValues {
  facilityName = '@AnleggNavn@',
  siteLocationName = '@LokalitetNavn@',
  siteNumber = '@LokalitetNR@',
  productionNumber = '@RessursProduksjonsnr@',
  orderNumber = '@RessursOrdrenr@',
  netType = '@RessursNotType@',
  netFunction = '@RessursNotFunksjon@',
  perimeter = '@RessursOmkrets@',
  cagePlacement = '@RessursBurPlassering@',
  resourcesName = '@RessursNavn@',
  positionName = '@RessursPosisjon@',
}

// Date/time fields store '1' as defaultValue when they should be filled with the current date/time (same as old system)
export const AUTO_FILL_DATE_TIME = '1'

export const CollectionFormFieldList = [FormFieldType.checkBoxList, FormFieldType.selectField, FormFieldType.radio]

export const DefaultValueIncludedFieldList = [FormFieldType.textField, FormFieldType.textArea]

export const AutoFillDateTimeFieldList = [FormFieldType.datePicker, FormFieldType.dateTime, FormFieldType.timePicker]

export const NotFieldTypes = [
  FormFieldType.title,
  FormFieldType.richText,
  FormFieldType.instructionImage,
  FormFieldType.instructionFile,
]
